<template>
  <div class="course-tabs layout-flex" :class="{'course-tabs--sticky': sticky}">
    <div class="course-tab layout-flex_block--1"
      v-for="(tab, index) in tabsData"
      :key="tab.name+'-'+index"
      :class="{active: tabIndex === index}"
      @click="handleTab(tab, index)">
      {{tab.name}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'CourseTabs',
  props: {
    tabsData: {
      type: Array,
      default: () => []
    },
    sticky: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tabIndex: 0,
    };
  },
  methods: {
    handleTab(tab, index) {
      this.tabIndex = index;
      this.$emit('onChange', { tab, index });
    }
  }
};
</script>

<style lang="stylus" scoped>
.course-tabs {
  height: 48px;
  padding-top: 6px;
  background: #fff;
  border-radius: 16px 16px 0px 0px;
  &.course-tabs--sticky {
    position: sticky;
    top: 0;
    z-index: 9;
  }
  .course-tab {
    position: relative;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6D6D80;
    &.active {
      color: #41414D;
      &::after {
        position: absolute;
        left: 50%;
        bottom: 0;
        content: ' ';
        width: 16px;
        height: 5px;
        margin-left: -8px;
        background: #FF5E2E;
        border-radius: 3px;
      }
    }
  }
}
</style>